import BWillisLayout from "layouts/BWillisLayout.jsx";
import PortalLayout from "layouts/PortalLayout.jsx";
import LoginPage from "views/bwillis/Auth/LoginPage.jsx";
import PortalLogin from "views/portal/PortalLogin.jsx";
import { Redirect } from "react-router-dom";
import React from "react";

function RootRedirect() {
  return <Redirect to="/bwillis/login" />;
}

var indexRoutes = [
  { path: "/bwillis/login", name: "BWillis Login", component: LoginPage },
  { path: "/bwillis", name: "BWillis", component: BWillisLayout },
  { path: "/portal/login", name: "Student Portal Login", component: PortalLogin },
  { path: "/portal", name: "Student Portal", component: PortalLayout },
  { path: "/", name: "Root", component: RootRedirect }
];

export default indexRoutes;
